<div class="assigned-training-programs">
	<div class="assigned-training-programs__header">
		<div class="assigned-training-programs__eyebrow">{{ 'Training.Assigned.Title' | translate }}</div>
		<p class="assigned-training-programs__subtitle">
			{{ 'Training.Assigned.Subtitle' | translate }}
		</p>
	</div>

	<div class="assigned-training-programs__filters" *ngIf="!vm.loading && !vm.error && vm.programs?.length">
		<button
			type="button"
			class="assigned-training-programs__filter"
			[class.assigned-training-programs__filter--active]="vm.selectedFilter === 'all'"
			(click)="vm.setFilter('all')">
			{{ 'Training.Assigned.Filter_All' | translate }}
		</button>
		<button
			type="button"
			class="assigned-training-programs__filter"
			[class.assigned-training-programs__filter--active]="vm.selectedFilter === 'in-progress'"
			(click)="vm.setFilter('in-progress')">
			{{ 'Training.Assigned.Filter_In_Progress' | translate }}
		</button>
		<button
			type="button"
			class="assigned-training-programs__filter"
			[class.assigned-training-programs__filter--active]="vm.selectedFilter === 'completed'"
			(click)="vm.setFilter('completed')">
			{{ 'Training.Assigned.Filter_Completed' | translate }}
		</button>
	</div>

	<loader-overlay *ngIf="vm.loading"></loader-overlay>

	<div class="assigned-training-programs__list" *ngIf="!vm.loading && !vm.error && vm.filteredPrograms?.length">
		<div class="training-card" *ngFor="let program of vm.filteredPrograms" (click)="vm.openProgram(program)">
			<div class="training-card-main">
				<div class="training-status-icon" [ngClass]="{
					'status-in-progress': vm.getProgramStatusKey(program) === 'in-progress',
					'status-completed': vm.getProgramStatusKey(program) === 'completed',
					'status-not-started': vm.getProgramStatusKey(program) === 'assigned'
				}">
					<svg *ngIf="vm.getProgramStatusKey(program) === 'completed'" viewBox="0 0 24 24"><path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/></svg>
					<svg *ngIf="vm.getProgramStatusKey(program) !== 'completed'" viewBox="0 0 24 24"><path d="M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z"/></svg>
				</div>

				<div class="training-card-info">
					<div class="training-card-title">{{ program.title }}</div>
					<div class="training-card-meta">
						<span><svg viewBox="0 0 24 24"><path d="M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H8V4h12v12z"/></svg> {{ program.totalModulesDisplay }} {{ 'Training.Programs.Modules' | translate }}</span>
						<span *ngIf="program.startedDisplay"><svg viewBox="0 0 24 24"><path d="M19 3h-1V1h-2v2H8V1H6v2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z"/></svg> {{ ('Training.Assigned.Started_On' | translate).replace('%s', program.startedDisplay) }}</span>
						<span *ngIf="vm.getProgramStatusKey(program) !== 'completed' && program.dueDisplay"><svg viewBox="0 0 24 24"><path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67V7z"/></svg> {{ ('Training.Assigned.Due_By' | translate).replace('%s', program.dueDisplay) }}</span>
						<span *ngIf="vm.getProgramStatusKey(program) === 'completed' && program.completedDisplay"><svg viewBox="0 0 24 24"><path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41L9 16.17z"/></svg> {{ ('Training.Assigned.Completed_On' | translate).replace('%s', program.completedDisplay) }}</span>
						<span class="status-badge" [ngClass]="{
							'badge-in-progress': vm.getProgramStatusKey(program) === 'in-progress',
							'badge-completed': vm.getProgramStatusKey(program) === 'completed',
							'badge-not-started': vm.getProgramStatusKey(program) === 'assigned'
						}">
							<span class="badge-dot" [ngClass]="{
								'badge-dot-orange': vm.getProgramStatusKey(program) === 'in-progress',
								'badge-dot-green': vm.getProgramStatusKey(program) === 'completed',
								'badge-dot-gray': vm.getProgramStatusKey(program) === 'assigned'
							}"></span>
							{{ vm.getProgramStatusLabel(program) }}
						</span>
					</div>
				</div>

				<div class="training-card-progress">
					<div class="progress-ring">
						<svg width="56" height="56" viewBox="0 0 56 56">
							<circle class="bg" cx="28" cy="28" r="23" fill="none" stroke-width="5"/>
							<circle
								cx="28"
								cy="28"
								r="23"
								fill="none"
								stroke-width="5"
								[attr.stroke-dasharray]="144.5"
								[attr.stroke-dashoffset]="program.progressStrokeOffset"
								[ngClass]="{
									'fg-orange': vm.getProgramStatusKey(program) === 'in-progress',
									'fg-green': vm.getProgramStatusKey(program) === 'completed',
									'fg-gray': vm.getProgramStatusKey(program) === 'assigned'
								}"></circle>
						</svg>
						<div class="progress-ring-text">{{ program.progressText }}</div>
					</div>
					<div class="progress-label">{{ ('Training.Assigned.Progress_Complete' | translate).replace('%s', program.progressPercent) }}</div>
				</div>

				<div class="training-card-actions">
					<button
						type="button"
						[class]="vm.getProgramStatusKey(program) === 'completed' ? 'btn-view' : 'btn-continue'"
						(click)="$event.stopPropagation(); vm.openModule(program)">
						{{ vm.getActionLabel(program) }} <span *ngIf="vm.getProgramStatusKey(program) !== 'completed'">→</span>
					</button>
					<a href="" class="btn-detail-link" (click)="$event.preventDefault(); $event.stopPropagation(); vm.openProgram(program)">
						{{ 'Training.Assigned.Open_Details' | translate }}
						<svg viewBox="0 0 24 24"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6z"/></svg>
					</a>
				</div>
			</div>
		</div>
	</div>

	<div class="assigned-training-programs__empty" *ngIf="!vm.loading && !vm.error && !vm.filteredPrograms?.length">
		{{ 'Training.Assigned.No_Programs' | translate }}
	</div>
</div>
